// extracted by mini-css-extract-plugin
export var numpadContainer = "_ol-1";
export var phoneButton = "_ol-0";